import {CaseStyle} from "kryo";
import {RecordIoType, RecordType} from "kryo/record";

import {$RunId, RunId} from "./run-id.mjs";

export interface RunIdRef {
  id: RunId;
}

export const $RunIdRef: RecordIoType<RunIdRef> = new RecordType<RunIdRef>({
  properties: {
    id: {type: $RunId},
  },
  changeCase: CaseStyle.SnakeCase,
});
